import React from 'react';
import { NavLink } from 'react-router-dom';

const NavigationItem = ({ name, link, icon, style }) => (
  <li className="dash-nav__item">
    <NavLink
      to={link}
      style={style}
      className="dash-nav__link"
      activeClassName="active"
    >
      <span className="dash-nav__ico">
        <i className={icon} aria-hidden="true" />
      </span>
      <span className="dash-nav__text">{name}</span>
      <span className="dash-nav__arrow">
        <i className="fa fa-long-arrow-right" />
      </span>
    </NavLink>
  </li>
);

export default NavigationItem;
